import React, { forwardRef } from "react";
import { Turnstile } from "@marsidev/react-turnstile";
import { config } from "../../config";

/**
 * Reusable Cloudflare Turnstile widget.
 * Exposes token via onToken; parent can call ref.current?.reset() to get a new token.
 */
const CaptchaWidget = forwardRef(function CaptchaWidget({ onToken, onExpire }, ref) {
  const handleSuccess = (token) => {
    if (onToken) onToken(token);
  };

  const handleExpire = () => {
    if (onToken) onToken("");
    if (onExpire) onExpire();
  };

  if (!config.turnstileSiteKey) {
    return null;
  }

  return (
    <div className="captcha-widget" style={{ marginBottom: 16, width: "100%" }}>
      <Turnstile
        ref={ref}
        siteKey={config.turnstileSiteKey}
        onSuccess={handleSuccess}
        onExpire={handleExpire}
        onError={() => {
          if (onToken) onToken("");
        }}
        options={{
          theme: "light",
          size: "flexible",
        }}
      />
    </div>
  );
});

export default CaptchaWidget;
